import { useCompanyStore } from "../states/store/Company";

export type CompanyInfo = {
  id: string;
  name: string;
  sigla: string;
  active: boolean;
};

const getCachedCompanies = (): CompanyInfo[] => {
  const fromStore = useCompanyStore.getState().availableCompanies;
  if (fromStore && fromStore.length > 0) return fromStore as CompanyInfo[];

  const fromStorage = localStorage.getItem("all_active_companies_cache");
  return fromStorage ? JSON.parse(fromStorage) : [];
};

export const getCompanyList = (): CompanyInfo[] => getCachedCompanies();

export const COMPANIES = new Proxy(
  {} as Record<string, CompanyInfo | undefined>,
  {
    get: (_target, companyId: string) => {
      const list = getCachedCompanies();
      const found = list.find((c) => c.id === companyId);
      return found;
    },
  }
);

export function getCompanySigla(id: string): string {
  return COMPANIES[id]?.sigla || "";
}

export function getCompanyName(id: string): string {
  return COMPANIES[id]?.name || id;
}

export const normalizeCityName = (name: string) => {
  if (!name || typeof name !== "string") return;

  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .trim();
};

export function getCompanyIdByName(name: string): string | undefined {
  const list = getCachedCompanies();
  const found = list.find(
    (info) => info.name.toUpperCase() === normalizeCityName(name)
  );

  return found ? found.id : undefined;
}
